<template>
  <router-view />
</template>
<style></style>
<style lang="less">
@font-face {
  font-family: heracomponents;
  font-display: block;
  src: url(https://sf1-scmcdn-tos.pstatp.com/goofy/hera-fe/static/fonts/hera-components.e3a8282f22.woff)
    format('woff');
}
i {
  font-family: heracomponents !important;

  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
